import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const EmptyState = ({ onClearFilters, hasFilters, searchTerm }) => {
  if (hasFilters || searchTerm) {
    return (
      <div className="text-center py-16">
        <div className="max-w-md mx-auto">
          <div className="w-24 h-24 mx-auto mb-6 bg-muted rounded-full flex items-center justify-center">
            <Icon name="Search" size={32} className="text-text-secondary" />
          </div>
          
          <h3 className="text-xl font-semibold text-text-primary mb-2">
            No Fabrics Found
          </h3>
          
          <p className="text-text-secondary mb-6">
            {searchTerm 
              ? `No fabrics match your search for "${searchTerm}". Try different keywords or clear filters.`
              : "No fabrics match your current filters. Try adjusting your selection or clear all filters."
            }
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button
              variant="default"
              onClick={onClearFilters}
              iconName="RotateCcw"
              iconPosition="left"
              iconSize={16}
            >
              Clear All Filters
            </Button>
            
            <Button
              variant="outline"
              iconName="MessageSquare"
              iconPosition="left"
              iconSize={16}
            >
              Contact for Custom Fabric
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="text-center py-16">
      <div className="max-w-md mx-auto">
        <div className="w-24 h-24 mx-auto mb-6 bg-muted rounded-full flex items-center justify-center">
          <Icon name="Package" size={32} className="text-text-secondary" />
        </div>
        
        <h3 className="text-xl font-semibold text-text-primary mb-2">
          Fabric Collection Coming Soon
        </h3>
        
        <p className="text-text-secondary mb-6">
          We're currently updating our fabric collection with our latest designs. Check back soon or contact us for fabric samples and catalogs!
        </p>

        <Button
          variant="default"
          iconName="MessageSquare"
          iconPosition="left"
          iconSize={16}
        >
          Request Fabric Samples
        </Button>
      </div>
    </div>
  );
};

export default EmptyState;